<div
  class="loader"
  *ngIf="loading"
  [@fadeOutAnimation]
  [@fadeInAnimation]
  [class.is--fixed]="fixed"
  [style.z-index]="zIndex">

  <div class="indicator type-spinner">
    <span class="indicator-item is--bounce1"></span>
    <span class="indicator-item is--bounce2"></span>
    <span class="indicator-item is--bounce3"></span>
  </div>
</div>
